import { render, staticRenderFns } from "./HolidayPopup.vue?vue&type=template&id=c08c2738&"
import script from "./HolidayPopup.vue?vue&type=script&lang=ts&"
export * from "./HolidayPopup.vue?vue&type=script&lang=ts&"
import style0 from "./HolidayPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports